<template>
  <dl class="block-timeline">
    <div v-for="entry in entries" :key="entry.label" class="timeline-entry">
      <dt class="entry-label">{{ entry.label }}</dt>
      <dd class="entry-text" v-html="entry.text" />
    </div>
  </dl>
</template>

<script setup>
const props = defineProps(['block'])
const entries = computed(() => props.block?.content?.entries || [])
</script>

<style scoped>
.block-timeline {
  display: grid;
  gap: 3rem 0;
  margin: 0;
}

.timeline-entry {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 2rem;
  padding-top: 3rem;
  border-top: 1px solid var(--fg-20, currentColor);
}

.timeline-entry:first-child {
  padding-top: 0;
  border-top: none;
}

.entry-label {
  font-size: 1.1rem;
  font-weight: 500;
  letter-spacing: 0.03em;
  margin: 0;
  padding-top: 0.2em;
}

.entry-text {
  margin: 0;
  font-size: 1.1rem;
  line-height: 1.65;
}

.entry-text :deep(p) {
  margin: 0 0 1em;
}

.entry-text :deep(p:last-child) {
  margin-bottom: 0;
}
</style>
